import React from 'react'
import classnames from 'classnames'
import './index.scss'

export const ResponsiveMainView = (props: any) => {
  return (
    <div {...props} className={classnames(props.className, 'responsive-main-view')}>
      {props.children}
    </div>
  )
}
